module.exports = __webpack_public_path__ + "img/cm_person3.6cff6db8.jpg";